import { render, staticRenderFns } from "./gl-score-level-chip.vue?vue&type=template&id=9442ed1a"
import script from "./gl-score-level-chip.vue?vue&type=script&lang=js"
export * from "./gl-score-level-chip.vue?vue&type=script&lang=js"
import style0 from "./gl-score-level-chip.vue?vue&type=style&index=0&id=9442ed1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports